<template>
  <b-card
    border-variant="light"
    no-body
    class="card-developer-meetup"
  >
    <b-card-body>
      <!-- metting header -->
      <div class="meetup-header d-flex align-items-center">
        <div class="meetup-day">
          <h6 class="mb-0">
            Solicitud
          </h6>
          <h3 class="mb-0">
            # {{ idOrden }}
          </h3>
        </div>
        <div class="my-auto">
          <b-card-title class="mb-25">
            <b-badge
              class="col-12 mt-2"
              :variant="(factura.aprobadoAdmin ==1) ? 'light-success' : 'light-warning' "
            >
              {{ ( factura.aprobadoAdmin ==1 ) ? 'Factura enviada a contabilidad el dia: '+formatDate(factura.fechaAprobAdmin, { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }) : 'Factura aun sin revisar' }}
            </b-badge>
            <b-badge
              class="col-12 mt-2"
              :variant="(factura.aprobadoContab ==1) ? 'light-success' : 'light-info' "
            >
              {{ ( factura.aprobadoContab ==1 ) ? 'Contabilidad reviso el dia: '+formatDate(factura.fechAprobContab, { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }) : 'Contabilidad aun sin revisar' }}
            </b-badge>
          </b-card-title>
        </div>
      </div>
      <!--/ metting header -->
      <!-- body detail -->
      <b-row lg="12">
        <!-- FECHA DE PAGO -->
        <b-col
          lg="6"
          md="6"
          class="mb-2"
        >
          <b-media
            no-body
          >
            <b-media-body>
              <h6 class="mb-0">
                FECHA DE PAGO
              </h6>
              <small>{{ solicitud.fecha_pago }}</small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- RAZON SOCIAL -->
        <b-col
          lg="6"
          md="6"
          class="mb-2"
        >
          <b-media
            no-body
          >
            <b-media-body>
              <h6 class="mb-0">
                RAZON SOCIAL
              </h6>
              <small>{{ factura.razon }}</small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- RFC -->
        <b-col
          lg="4"
          md="4"
        >
          <b-media
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-primary"
                size="34"
                text="RFC"
              />
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                R.F.C.
              </h6>
              <small>{{ factura.rfc }}</small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- CURP -->
        <b-col
          lg="4"
          md="4"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-primary"
                size="34"
                text="CRP"
              />
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                CURP
              </h6>
              <small> {{ persona.curp }} </small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- CODIGO POSTAL -->
        <b-col
          lg="4"
          md="4"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-primary"
                size="34"
                text="CRP"
              />
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                CODIGO POSTAL
              </h6>
              <small> {{ factura.cp }} </small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- ESTADO -->
        <b-col
          lg="6"
          md="6"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-body>
              <h6 class="mb-0">
                ESTADO
              </h6>
              <small> {{ factura.estado }} </small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- MUNICIPIO -->
        <b-col
          lg="6"
          md="6"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-body>
              <h6 class="mb-0">
                MUNICIPIO
              </h6>
              <small> {{ factura.municipio }} </small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- Telefonos -->
        <b-col
          lg="4"
          md="4"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-primary"
                size="34"
                text="CRP"
              />
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                TELÉFONO (S)
              </h6>
              <small> {{ persona.telefono1 }} / {{ persona.telefono2 }} ext. {{ persona.extension }} </small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- correo 1 -->
        <b-col
          lg="4"
          md="4"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-primary"
                size="34"
                text="1"
              />
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                CORREOS (1)
              </h6>
              <small> {{ factura.correo1 }} </small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- correo 2 -->
        <b-col
          lg="4"
          md="4"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-primary"
                size="34"
                text="2"
              />
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                CORREOS (2)
              </h6>
              <small> {{ factura.correo2 }} </small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- METODO DE PAGO 1 -->
        <b-col
          lg="6"
          md="6"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-body>
              <h6 class="mb-0">
                METODOS DE PAGO
              </h6>
              <small> {{ solicitud.metodoPago }} </small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- FORMA DE PAGO 2 -->
        <b-col
          lg="6"
          md="6"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-body>
              <h6 class="mb-0">
                FORMA DE PAGO
              </h6>
              <small> {{ solicitud.forma_pago }} </small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- USO DE CFDI -->
        <b-col
          lg="6"
          md="6"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-body>
              <h6 class="mb-0">
                Uso de CFDI
              </h6>
              <small>{{ factura.usoCFDI }}</small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- APORTACION -->
        <b-col
          lg="6"
          md="6"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-body>
              <h6 class="mb-0">
                APORTACIÓN
              </h6>
              <small> {{ solicitud.monto }} </small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- calle -->
        <b-col
          lg="4"
          md="4"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-primary"
                size="34"
                text="CLE"
              />
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                Calle
              </h6>
              <small>{{ factura.calle }}</small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- num ext -->
        <b-col
          lg="4"
          md="4"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-primary"
                size="34"
                text="EXT"
              />
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                Num Ext. e Int.
              </h6>
              <small>{{ (factura.numero) ? 'Ext: '+factura.numero : '' }}  {{ (factura.interior) ? ', Int: '+factura.interior : '' }}</small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- codigo postal -->
        <b-col
          lg="4"
          md="4"
          class="mb-1"
        >
          <b-media
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-primary"
                size="34"
                text="CP"
              />
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                C.P.
              </h6>
              <small>{{ factura.cp }}</small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- colonia -->
        <b-col
          lg="6"
          md="6"
        >
          <b-media
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-primary"
                size="34"
                text="CLN"
              />
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                Colonia
              </h6>
              <small>{{ factura.colonia }}</small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- referencias -->
        <b-col
          lg="6"
          md="6"
        >
          <b-media
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-primary"
                size="34"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="18"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                Referencias
              </h6>
              <small>{{ (factura.ref1) ? 'Ref 1: '+factura.ref1 : '' }} {{ (factura.ref2) ? 'Ref 2: '+factura.ref2 : '' }}</small>
            </b-media-body>
          </b-media>
        </b-col>
        <!-- nombre de la persona -->
        <b-col
          lg="12"
          md="12"
          class="mt-2"
        >
          <b-media
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-primary"
                size="34"
              >
                <feather-icon
                  icon="UserIcon"
                  size="18"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                Nombre de la persona
              </h6>
              <small>{{ persona.nombreCompleto }}</small>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col md="12">
          <b-input-group class="m-2">
            <b-form-textarea
              id="txtobservaciones"
              plaintext
              :value="(factura.observaciones) ? factura.observaciones : 'Sin observaciones'"
              rows="3"
              no-resize
            />
          </b-input-group>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BCardTitle,
  BMedia,
  BMediaAside,
  BAvatar,
  VBTooltip,
  BMediaBody,
  BBadge,
  BInputGroup,
  BFormTextarea,
} from 'bootstrap-vue'
import { formatDate } from '@core/utils/filter'

/* eslint-disable global-require */
export default {
  components: {
    BCard,
    BBadge,
    BCardBody,
    BCardTitle,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BRow,
    BCol,
    BInputGroup,
    BFormTextarea,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    persona: {
      type: Object,
      default: () => {},
    },
    solicitud: {
      type: Object,
      default: () => {},
    },
    factura: {
      type: Object,
      default: () => {},
    },
    idOrden: {
      type: [String, Number],
      default: '0',
    },
  },
  setup() {
    return {
      formatDate,
    }
  },
}
</script>
